import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'thtd/GLTFLoader.js';
import { DRACOLoader } from 'thtd/DRACOLoader.js';

// Vše (three, loadery, Draco dekodér, GLB modely, bump textura) je self-hostované
// v theme assets — viz importmap v snippets/head.liquid. ASSETS_BASE je adresář
// assets odvozený z URL tohoto modulu (Draco a modely se načítají bez ?v= parametru).
const ASSETS_BASE = new URL('.', import.meta.url).href;

// Tvrdý strop délky jména na dresu (viz applyName v build3DScene). Je i na
// module scope, aby šel limit vynutit i bez WebGL2 (viz window.onload) — jinak
// by ho nastavoval jen kód uvnitř build3DScene, který se bez WebGL2 nespustí.
const NAME_MAX_LENGTH = 13;

// Fork of rychidesign/thtd-three-setup konfigurator_7.js.
// Option inputs are read via data attributes rendered by
// snippets/custom-product-options.liquid instead of the Globo Product Options DOM:
//   - input[data-option-type="color"] + data-field-name + data-color  -> SVG color targets
//   - input[data-field-name="sleeve"] + data-value (long/short)       -> model switch
//   - input[data-field-name="name"]                                   -> name on jersey

// Zjistit, zda je dostupná funkce WebGL 2.0
var isWebGL2Supported = (function () {
    try {
      var canvas = document.createElement('canvas');
      return !!(
        window.WebGL2RenderingContext && (canvas.getContext('webgl2') || canvas.getContext('experimental-webgl2')));
    } catch (e) {
      return false;
    }
})();

function checkWebGLSupport(){
    if(isWebGL2Supported){
        build3DScene();
    }else{
        console.log('! Browser does not support WebGL !');
    };
};

// Design SVG se stahuje ze Shopify Files (metafield custom.design_svg, CORS *).
// Když je SVG už inline v DOM nebo atribut chybí, pokračuje se rovnou (zpětná kompatibilita).
async function loadDesignSvg(){
    const holder = document.querySelector('.svg_design');
    if(!holder || holder.firstElementChild){
        return;
    };
    const src = holder.getAttribute('data-design-src');
    if(!src){
        return;
    };
    try {
        const res = await fetch(src);
        if(!res.ok){
            throw new Error('HTTP ' + res.status);
        };
        holder.innerHTML = await res.text();
    } catch (e) {
        console.error('! 3D configurator: design SVG fetch failed !', e);
    };
};

window.onload = function(){
    // Limit délky jména vynutíme i bez WebGL2 (build3DScene by se jinak nespustil):
    // když input nemá maxlength z metafieldu, dosaď ho nativně.
    var ni = document.querySelector('input[data-field-name="name"]');
    if(ni && !ni.getAttribute('maxlength')){
        ni.setAttribute('maxlength', NAME_MAX_LENGTH);
    };
    loadDesignSvg().then(checkWebGLSupport);
};

function build3DScene(){
        /* Base =================================================================================*/

        // CONFIGURATOR
        var configuratorSetUp = {
            design: 'custom_design',
            longSleeve: 'long_sleeve_12.glb',
            shortSleeve: 'short_sleeve_12.glb',
            name: true
        }
        // Canvas
        const canvas = document.getElementById('canvas-3d');
        const loaderWrapper = document.getElementById('loader-wrapper');
        const wrapper = document.querySelector('.cpo-3d-sticky') || document.querySelector('div.product_3d_wrapper');
        const productRotationEl = document.getElementById('product_rotation');
        const ambientColor = '#ffffff';
        const ambientIntensity = '0.8';

        /* CONFIGURATOR =================================================================================*/

        var svgCode = document.querySelector(`[design-id="${configuratorSetUp.design}"]`);
        var svgStyle = svgCode ? svgCode.firstElementChild : null;
        var colorInputs = document.querySelectorAll('input[data-option-type="color"]');
        var sleeveInputs = document.querySelectorAll('input[data-field-name="sleeve"]');
        var nameInput = document.querySelector('input[data-field-name="name"]');
        var nameOnDesign = document.querySelector(`[design-id="${configuratorSetUp.design}"] text[name-id="name"]`);

        if(!canvas || !wrapper || !svgCode || !svgStyle){
            console.log('! 3D configurator: missing canvas or SVG design, skipping !');
            return;
        };

        const productRotation = productRotationEl ? productRotationEl.innerHTML : 0;

        function isLongSleeveSelected(){
            var checked = document.querySelector('input[data-field-name="sleeve"]:checked');
            if(!checked){
                return true;
            };
            return checked.getAttribute('data-value') !== 'short';
        };

        /*
        // PRELOADER
        */
        // Render-on-demand: render jen když se kamera hýbe (controls.update()
        // vrací true) nebo když se změní scéna (thtdNeedsRender) — barva/design/
        // jméno/rukávy/load. Nepřetržitá 60fps smyčka renderovala i statickou
        // scénu — bez GPU akcelerace (vč. Lighthouse/PSI) blokovala main thread.
        let thtdNeedsRender = true;
        // Po dobu aktivního gesta (drag/pinch) renderujeme každý snímek — viz
        // 'start'/'end' listenery na controls. Spoléhat během gesta jen na
        // 'change'/update() je nespolehlivé (EPS práh, dvojí update() za snímek,
        // slučování touch eventů v Chrome → ztracené snímky = zamrzlý zoom).
        let thtdInteracting = false;
        const loadingManager = new THREE.LoadingManager(
            //LOADED
            () =>
            {
                console.log('>> loaded <<');
                thtdNeedsRender = true;
                loaderWrapper.classList.add('is-hidden');
                document.querySelectorAll('.product_3d_poster').forEach(function (p) { p.classList.add('is-hidden'); });
            },
            //PROGRESS
            () =>
            {
                console.log('progress');
                loaderWrapper.classList.remove('is-hidden');
            }
        )


        // Scene
        const scene = new THREE.Scene();

        /* Loaders =================================================================================*/

        // Texture loader
        const textureLoader = new THREE.TextureLoader(loadingManager);

        // Draco loader
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath(ASSETS_BASE);

        // GLTF loader
        const gltfLoader = new GLTFLoader(loadingManager);
        gltfLoader.setDRACOLoader(dracoLoader);


        /* Lights =================================================================================*/

        // Spot light 01
        const spotLight = new THREE.SpotLight();
        spotLight.color = new THREE.Color(0xffffff);
        spotLight.intensity = 14;
        spotLight.position.y = 0.3;
        spotLight.position.x = 1.5;
        spotLight.position.z = 1;
        spotLight.castShadow = true;

        spotLight.shadow.mapSize.width = 512;
        spotLight.shadow.mapSize.height = 512;
        spotLight.shadow.camera.near = 0.5;
        spotLight.shadow.camera.far = 400;
        spotLight.shadow.focus = 1;

        scene.add(spotLight);


        // Back Spot light 02
        const spotLight02 = new THREE.SpotLight();
        spotLight02.color = new THREE.Color(0xffffff);
        spotLight02.intensity = 10;
        spotLight02.position.y = 0.5;
        spotLight02.position.x = -1;
        spotLight02.position.z = -2;
        //spotLight02.castShadow = true;
        scene.add(spotLight02);

        // Back Spot light 03
        const spotLight03 = new THREE.SpotLight();
        spotLight03.color = new THREE.Color(0xffffff);
        spotLight03.intensity = 6;
        spotLight03.position.y = 0.5;
        spotLight03.position.x = 1;
        spotLight03.position.z = -2;
        //spotLight03.castShadow = true;
        scene.add(spotLight03);

        const lightsGroup = new THREE.Group();
        lightsGroup.add(spotLight, spotLight02, spotLight03);
        scene.add(lightsGroup);


        // Ambient Spot light 03
        const AmbientLight = new THREE.AmbientLight();
        AmbientLight.color = new THREE.Color(ambientColor);
        AmbientLight.intensity = ambientIntensity;
        scene.add(AmbientLight);


        /* Textures =================================================================================*/

        //Long sleeve textures
        // Placeholder bez URL — textureLoader.load() bez argumentu by stáhl
        // "<url>/undefined" (celou 404 stránku) jako obrázek na každém zobrazení.
        // Skutečná textura se dosadí v generateImage() z vyrenderovaného SVG.
        var bakedTexture = new THREE.Texture();
        bakedTexture.flipY = false;

        bakedTexture.colorSpace = THREE.SRGBColorSpace;

        const bumpTexture = textureLoader.load(ASSETS_BASE + 'bake_bump_2.jpg');
        bumpTexture.flipY = false;

        console.log("textures ready");

        /* Materials =================================================================================*/

        // Baked Long sleeve material
        var bakedMaterial = new THREE.MeshStandardMaterial({
            map: bakedTexture,
            roughness: 0.85,
            bumpMap: bumpTexture,
            bumpScale: 2.5,
            side: THREE.DoubleSide,
            color: new THREE.Color(0xffffff),
        });

        /* Model =================================================================================*/

        const dresGroup = new THREE.Group();
        var dresMeshLong;
        var dresMeshShort;

        gltfLoader.load(ASSETS_BASE + configuratorSetUp.longSleeve, (gltf) =>
            {
                dresMeshLong = gltf.scene;
                dresMeshLong.traverse((child) =>
                {
                    child.material = bakedMaterial;
                })
                dresGroup.add(dresMeshLong);
                dresMeshLong.visible = isLongSleeveSelected();
            }
        )
        gltfLoader.load(ASSETS_BASE + configuratorSetUp.shortSleeve, (gltf) =>
            {
                dresMeshShort = gltf.scene;
                dresMeshShort.traverse((child) =>
                {
                    child.material = bakedMaterial;
                })
                dresGroup.add(dresMeshShort);
                dresMeshShort.visible = !isLongSleeveSelected();
            }
        )

        scene.add( dresGroup );
        dresGroup.rotation.y = Math.PI/10 * productRotation;


        /* Sizes =================================================================================*/

        const sizes = {
            width: wrapper.getBoundingClientRect().width,
            height: wrapper.getBoundingClientRect().height
        };

        window.addEventListener('resize', () =>
        {
            // Update sizes
            sizes.width = wrapper.getBoundingClientRect().width;
            sizes.height = wrapper.getBoundingClientRect().height;
            // Update camera
            camera.aspect = sizes.width / sizes.height
            camera.updateProjectionMatrix();
            // Update renderer
            renderer.setSize(sizes.width, sizes.height);
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
            renderer.render(scene, camera);
        });



        /* Camera =================================================================================*/

        // Base camera
        const camera = new THREE.PerspectiveCamera(30, sizes.width / sizes.height, 0.1, 100);
        camera.position.x = 0.26;
        camera.rotation.x = Math.PI /20;
        camera.position.y = -0.2
        camera.position.z = 1.2
        camera.add(lightsGroup);
        scene.add(camera);

        /* Renderer =================================================================================*/

        const renderer = new THREE.WebGLRenderer({
            canvas: canvas,
            antialias: true,
            alpha: true,
            shadowMapEnabled: true
        })
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        renderer.setSize(sizes.width, sizes.height);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        renderer.outputColorSpace = THREE.SRGBColorSpace;


        const controls = new OrbitControls( camera, canvas );
        controls.enableDamping = true;
        controls.minDistance = 0.5;
        controls.maxDistance = 1.2;
        controls.enableZoom = false;
        controls.enablePan = false;
        controls.minPolarAngle = Math.PI / 4;
        controls.maxPolarAngle = Math.PI / 1.5;
        controls.dampingFactor = 0.1;
        // Render-on-demand: každá skutečná změna kamery si vyžádá jeden render.
        // 'change' se dispatchne při změně kamery (i z dampingu po puštění).
        controls.addEventListener('change', () => { thtdNeedsRender = true; });
        // Během celého gesta renderuj každý snímek (řeší ztrátu snímků uprostřed
        // pinche/dragu). Po 'end' necháme doběhnout damping přes 'change'.
        controls.addEventListener('start', () => { thtdInteracting = true; });
        controls.addEventListener('end',   () => { thtdInteracting = false; thtdNeedsRender = true; });

        // Android Chrome si u dvouprstého gesta rezervuje page-zoom a po pár
        // snímcích pointery zruší (pointercancel) → OrbitControls dostane 'end'
        // a zoom během pinche zamrzne (jednoprstá rotace jede dál). Samotné
        // touch-action:none (nastavuje OrbitControls na canvas) na to nestačí;
        // explicitní preventDefault na multitouch řekne prohlížeči, že
        // dvouprsté gesto obsluhujeme my. Jednoprsté gesto necháváme být.
        const thtdPreventMultiTouch = (e) => { if (e.touches.length > 1) e.preventDefault(); };
        canvas.addEventListener('touchstart', thtdPreventMultiTouch, { passive: false });
        canvas.addEventListener('touchmove',  thtdPreventMultiTouch, { passive: false });

        controls.update();
        if(sizes.width < 439){
            controls.enableZoom = true;
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        };

       /* CONFIGURATOR =================================================================================*/

        sleeveInputs.forEach((input) => {
            input.addEventListener('change', function() {
                var showLong = this.getAttribute('data-value') !== 'short';
                if(dresMeshLong){
                    dresMeshLong.visible = showLong;
                };
                if(dresMeshShort){
                    dresMeshShort.visible = !showLong;
                };
                thtdNeedsRender = true;
            });
        });

        let timeout;
        if(nameInput && nameOnDesign){
            nameInput.addEventListener('keyup', function(){
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    ensureNameFont().then(function(){
                        applyName(nameInput.value);
                        generateImage();
                    });
                }, 500);
            });
        };

        var designSetUp = {
            bg_color: '#000000',
            primary_color: '#333333',
            secondary_color: '#cccccc',
            tertiary_color: '#FFFFFF',
            quaternary_color: '',
            font_family:  'UniSansHeavyCAPS',
            font_size: '180'
        }

        /* Jméno na zádech: limit délky + auto-zmenšení ==============================
        // Design má viewBox "0 0 4096 4096" a text jména je vycentrovaný na x=2048
        // (text-anchor="middle"). Tiskový blok zadního panelu je kolem něj zhruba
        // 1380 jednotek široký; uvnitř něj je světlejší „cedulka" na jméno cca 1050
        // jednotek. Jméno má sedět uvnitř té cedulky, takže NAME_MAX_WIDTH je pod ní.
        // Když jméno při základní velikosti fontu tuhle šířku přesáhne, font se úměrně
        // zmenší, aby se vešlo. Tvrdý strop délky drží NAME_MAX_LENGTH (module scope).
        // Čísla jsou k doladění podle designu (menší NAME_MAX_WIDTH = užší jméno). */
        const NAME_MAX_WIDTH = 900;    // jednotky SVG viewBoxu (0..4096); menší = užší
        const NAME_MIN_FONT_SIZE = 60; // podlaha px, ať i nejdelší jméno vejde a nezmizí

        // Font pro měření: @font-face fontu je jen uvnitř staženého SVG, které je
        // display:none (.hidden_parameters + inline style na <svg>). Takový font se
        // do hlavního dokumentu líně nenačte, takže canvas measureText by měřil
        // náhradním fontem a auto-zmenšení by počítalo se špatnými šířkami. Font
        // proto z SVG vytáhneme a explicitně zaregistrujeme do document.fonts, pak
        // počkáme na jeho načtení (je to data-URI, takže bez síťového požadavku).
        var nameFontPromise = null;
        function ensureNameFont(){
            if(nameFontPromise){ return nameFontPromise; };
            var family = designSetUp.font_family;
            if(!document.fonts){
                nameFontPromise = Promise.resolve(false);
                return nameFontPromise;
            };
            try {
                var faceSrc = null;
                var styleEls = svgCode.querySelectorAll('style');
                for(var i = 0; i < styleEls.length; i++){
                    var m = styleEls[i].textContent.match(/@font-face[^}]*?src\s*:\s*url\((['"]?)([^'")]+)\1\)/i);
                    if(m){ faceSrc = m[2]; break; };
                };
                if(faceSrc && typeof FontFace !== 'undefined'){
                    var face = new FontFace(family, 'url("' + faceSrc + '")');
                    document.fonts.add(face);
                    nameFontPromise = face.load().then(function(){ return true; }, function(){ return false; });
                    return nameFontPromise;
                };
            } catch(e){ /* spadneme na fallback níž */ };
            // Fallback: zkus načíst CSS-connected @font-face (pokud ho prohlížeč
            // z injektovaného SVG do document.fonts sám zaregistroval).
            nameFontPromise = (document.fonts.load ? document.fonts.load("180px '" + family + "'") : Promise.resolve())
                .then(function(){ return true; }, function(){ return false; });
            return nameFontPromise;
        };

        // Změř šířku textu při dané velikosti fontu. Font už musí být načtený
        // (viz ensureNameFont), jinak by measureText počítal náhradním fontem.
        const nameMeasureCtx = document.createElement('canvas').getContext('2d');
        function measureNameWidth(text, fontSizePx){
            nameMeasureCtx.font = fontSizePx + "px '" + designSetUp.font_family + "'";
            return nameMeasureCtx.measureText(text).width;
        };

        // Nastaví jméno do SVG textu a případně zmenší font, aby se vešlo na panel.
        function applyName(rawValue){
            // NAME_MAX_LENGTH je tvrdý strop: metafield maxlength může délku už jen
            // zkrátit pod něj, nikdy zvýšit nad něj.
            var attr = parseInt(nameInput.getAttribute('maxlength'), 10);
            var limit = Math.min(isNaN(attr) ? NAME_MAX_LENGTH : attr, NAME_MAX_LENGTH);
            // textContent (ne innerHTML): jméno je čistý text; znaky jako < & by
            // jinak rozbily serializaci SVG do textury v generateImage().
            var text = (rawValue || '').slice(0, limit);
            nameOnDesign.textContent = text;

            // Šířka textu je lineární k velikosti fontu → změříme při základní
            // velikosti a dopočítáme měřítko.
            var baseSize = parseFloat(designSetUp.font_size) || 180;
            var width = measureNameWidth(text, baseSize);
            var size = baseSize;
            if(width > NAME_MAX_WIDTH){
                size = Math.max(NAME_MIN_FONT_SIZE, baseSize * NAME_MAX_WIDTH / width);
            };
            // font-size textu jde ze třídy .font_size; inline styl ji přebije.
            // Inline nastavíme jen při zmenšení, jinak necháme základ ze třídy
            // (aby jméno po smazání znaků zase narostlo zpět).
            nameOnDesign.style.fontSize = (size < baseSize) ? (size.toFixed(1) + 'px') : '';
        };

        function updatedesignSetUp (colorTarget, colorValue){
            switch (colorTarget) {
                case 'bg_color':
                    designSetUp.bg_color = colorValue;
                    console.log(colorTarget + " - " + colorValue);
                    break;
                case 'primary_color':
                    designSetUp.primary_color = colorValue;
                    console.log(colorTarget + " - " + colorValue);
                    break;
                case 'secondary_color':
                    designSetUp.secondary_color = colorValue;
                    console.log(colorTarget + " - " + colorValue);
                    break;
                case 'tertiary_color':
                    designSetUp.tertiary_color = colorValue;
                    console.log(colorTarget + " - " + colorValue);
                    break;
                case 'quaternary_color':
                    designSetUp.quaternary_color = colorValue;
                    console.log(colorTarget + " - " + colorValue);
                    break;
                case 'font_family':
                    designSetUp.font_family = colorValue;
                    console.log(colorTarget + " - " + colorValue);
                    break;
                case 'font_size':
                    designSetUp.font_size = colorValue;
                    console.log(colorTarget + " - " + colorValue);
                    break;
                default:
                    console.log(`Nenašel jsem ${colorTarget}.`);
            }
            svgStyle.innerHTML =
            `
            .bg_color {fill: ${designSetUp.bg_color};}
            .primary_color {fill: ${designSetUp.primary_color};}
            .secondary_color {fill: ${designSetUp.secondary_color};}
            .tertiary_color {fill: ${designSetUp.tertiary_color};}
            .quaternary_color {fill: ${designSetUp.quaternary_color};}
            .font_family {font-family: '${designSetUp.font_family}';}
            .font_size {font-size: ${designSetUp.font_size}px;}
        `
        }

        function generateImage(){
            let svgAsString = svgCode.parentNode.innerHTML;
            const svgWidth = svgCode.viewBox.baseVal.width;
            const svgHeight = svgCode.viewBox.baseVal.height;

            let svgBlob = new Blob([svgAsString], {type: 'image/svg+xml'});
            // Blob URL držíme v lokální proměnné (ne sdílené): dva rychle po sobě
            // jdoucí generateImage() (např. rychlé přebarvování) si tak nepřepíšou
            // URL a každý revokne přesně ten svůj → žádný leak ani záměna textury.
            const localBlobURL = globalThis.URL.createObjectURL(svgBlob);
            let img = document.createElement('img');

            var onImageLoaded = () => {
                var canvas = document.createElement('canvas');
                canvas.width = svgWidth;
                canvas.height = svgHeight;
                var context = canvas.getContext('2d');

                var createdImage = document.createElement('img');

                context.drawImage(img, 0, 0, svgWidth, svgHeight);
                createdImage.src = canvas.toDataURL('image/jpg');

                //TextureLoader
                bakedTexture = textureLoader.load(createdImage.src);
                bakedTexture.flipY = false;
                bakedTexture.colorSpace = THREE.SRGBColorSpace;
                bakedTexture.minFilter = THREE.LinearFilter;
                bakedMaterial.map = bakedTexture;

                globalThis.URL.revokeObjectURL(localBlobURL);
            };

            img.addEventListener('load', function (e) { onImageLoaded(e); thtdNeedsRender = true; });
            img.src = localBlobURL;
            console.log("generateImage done")
        };

        // Apply preselected color options so the 3D preview matches the form defaults
        colorInputs.forEach((input) => {
            if(input.checked){
                var fieldName = input.getAttribute('data-field-name');
                var colorValue = input.getAttribute('data-color');
                if(fieldName && colorValue){
                    updatedesignSetUp(fieldName, colorValue);
                };
            };
        });

        // Počáteční render. Když je vyplněné jméno (obnovené po soft reloadu),
        // s prvním renderem počkáme na načtení fontu a vyrenderujeme rovnou se
        // správným jménem i velikostí — žádný problik placeholderu "Name" ani
        // dvojí render. Bez jména renderujeme design hned a font jen přednačteme
        // (kvůli přesnému měření při prvním psaní).
        var hasRestoredName = nameInput && nameOnDesign && nameInput.value !== '';
        if(!hasRestoredName){
            generateImage();
        };
        if(nameInput && nameOnDesign){
            ensureNameFont().then(function(){
                if(nameInput.value !== ''){
                    applyName(nameInput.value);
                    generateImage();
                };
            });
        };

        colorInputs.forEach((input) => {
            input.addEventListener('change', function() {
                var bttnTargetColor = this.getAttribute('data-field-name');
                var bttnColorValue = this.getAttribute('data-color');
                console.log("target:" + bttnTargetColor + " / " + "value:" + bttnColorValue)

                updatedesignSetUp(bttnTargetColor, bttnColorValue);
                generateImage();
            });
        });

        /* Animate =================================================================================*/

        const tick = () =>
        {
            // Damping musí běžet každý snímek. Render ale řídíme přes
            // thtdNeedsRender (nastavuje ho 'change' listener na controls výše),
            // ne přes návratovou hodnotu update() — tu si OrbitControls při
            // dotykovém gestu "spotřebuje" svým interním update() voláním.
            controls.update();
            if (thtdNeedsRender || thtdInteracting) {
                renderer.render(scene, camera);
                thtdNeedsRender = false;
            }
            // Call tick again on the next frame
            window.requestAnimationFrame(tick);
        }
        tick();
};
